<template>
  <div class="footer">
    <div
      v-for="(item, index) in btnGroup"
      :key="index"
      class="box"
      :class="[{'active':currentIndex==item.id},item.icon]"
      @click="goTo(item.id, item.path)"
    >
      <i class="glyphicon" :class="'glyphicon-'+item.icon"></i>
      {{item.name}}
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      // currentIndex: myutil.isDeskApp?'4':'4'
      currentIndex: ""
    };
  },
  computed: {
    btnGroup: function() {
      return [
            {
              name: this.$t("footer.market"),
              id: 1,
              icon: "home",
              path: "/"
            },
            {
              name: this.$t("footer.optional"),
              id: 2,
              icon: "th-list",
              path: "/Optional"
            },
            {
              name: this.$t("footer.news"),
              id: 3,
              icon: "globe",
              path:
                this.$store.state.langOnPage.other == "zh" ? "/News" : "/News"
            },
            {
              name: this.$t("footer.mine"),
              id: 4,
              icon: "user",
              path: "/Mine"
            }
          ];
        if (!window.location.host || window.location.host.search("starfintex") != -1) {
          // 如果是客户端
          return [
            // {
            //   name: this.$t("footer.home"),
            //   id: 1,
            //   icon: "home",
            //   path: "/"
            // },
            {
              name: this.$t("footer.market"),
              id: 5,
              icon: "globe",
              path: "/IntroMarket"
            },
            {
              name: this.$t("footer.optional"),
              id: 2,
              icon: "th-list",
              path: "/Optional"
            },
            {
              name: this.$t("footer.news"),
              id: 3,
              icon: "globe",
              path:
                this.$store.state.langOnPage.other == "zh" ? "/News" : "/News"
            },
            {
              name: this.$t("footer.mine"),
              id: 4,
              icon: "user",
              path: "/Mine"
            }
          ];
        } else {
          return [
            {
              name: this.$t("footer.home"),
              id: 1,
              icon: "home",
              path: "/"
            },
            {
              name: this.$t("footer.market"),
              id: 2,
              icon: "th-list",
              path: "/IntroMarket"
            },
            // {
            //   name: this.$t("footer.optional"),
            //   id: 2,
            //   icon: "th-list",
            //   path: "/Optional"
            // },
            {
              name: this.$t("footer.news"),
              id: 3,
              icon: "globe",
              path:
                this.$store.state.langOnPage.other == "zh" ? "/News" : "/News"
            },
            {
              name: this.$t("footer.mine"),
              id: 4,
              icon: "user",
              path: "/Mine"
            }
          ];
        }
    }
  },
  mounted: function() {
    this.currentIndex = window.localStorage.getItem("currentIndex");
  },
  methods: {
    goTo: function(id, _path) {
      window.localStorage.setItem("currentIndex", id); // 当前tab 全局保存

      this.currentIndex = id;
      this.$router.push({ path: _path });
    }
  }
};
</script>

<style lang="less" scoped>
.footer {
  z-index: 999;
  height: 50px;
  line-height: 50px;
  // background: #f8f8f8;
  background: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #ddd;
  .box {
    width: 25%;
    float: left;
    color: #525358;
  }
  div {
    cursor: pointer;
  }
  .active {
    color: #2eaaed;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/Footer.vue